import React from "react";

const InstagramIcon = ({className='stroke-zinc-900 ', iconClassName='w-8 h-8'}) => {
 

  return (
    
                
    <div className={` ${className} `}>
    
    <svg viewBox="0 0 24 24" fill="none" className={` ${iconClassName} `}>
      <path d="M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7" stroke="stroke-inherit" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" stroke="stroke-inherit" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.636 7h.012" stroke="stroke-inherit" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>


                
    </div>       
              
             
           
  );
};

export default InstagramIcon;